import { axios, transformAxiosError } from "../utils/axios.create";
import { RolePayload, RoleType, UserRoleType } from "../domain/rol.interface";

const findAll = async ({ status }: { status: string }): Promise<RoleType[]> => {
  return axios
    .get(`/roles?status=${status}`)
    .then((res) => {
      return res.data.body as RoleType[];
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findById = async (id: string): Promise<RoleType> => {
  return axios
    .get(`/roles/${id}`)
    .then((res) => {
      return res.data.body as RoleType;
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findByUserId = async (userId: string): Promise<UserRoleType[]> => {
  return axios
    .get(`/users/${userId}/roles`)
    .then((res) => {
      return res.data.body as UserRoleType[];
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export type RolesFindAllPayload = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
  status: string;
  type: string;
  subType: string;
};

const findAllPaginated = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  status,
  type,
  subType,
}: RolesFindAllPayload): Promise<{
  list: RoleType[];
  totalCount: number;
}> => {
  const queryParams = new URLSearchParams({
    search,
    status,
    type,
    subType,
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/roles/search?${queryParams.toString()}`)
    .then((res) => ({
      list: res.data.body.list as RoleType[],
      totalCount: res.data.body.totalCount as number,
    }))
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const createOne = async (payload: RolePayload): Promise<RoleType> => {
  return axios
    .post("/roles", payload)
    .then((res) => res.data.body as RoleType)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const updateOne = async ({
  id,
  payload,
}: {
  id: string;
  payload: RolePayload;
}): Promise<RoleType> => {
  return axios
    .put(`/roles/${id}`, payload)
    .then((res) => res.data.body as RoleType)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const archiveOne = async (id: string): Promise<void> => {
  return axios
    .delete(`/roles/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const RolesService = {
  findAll,
  findById,
  findByUserId,
  findAllPaginated,
  createOne,
  updateOne,
  archiveOne,
};
